import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLeadDripSequences as GetLeadDripSequencesQuery,
    LeadDripSequencesFragment,
    GetLeadDripSequencesVariables,
} from 'nutshell-graphql-types';

import GET_LEAD_DRIP_SEQUENCES from '../queries/get-lead-drip-sequences.graphql';

export const useGetLeadDripSequences = (
    leadId: string
): {
    dripSequences: LeadDripSequencesFragment | null | undefined;
    isLoading: boolean;
    isFirstLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {networkStatus, data, error, refetch, loading} = useQuery<
        GetLeadDripSequencesQuery,
        GetLeadDripSequencesVariables
    >(GET_LEAD_DRIP_SEQUENCES, {
        variables: {
            leadId,
        },
        fetchPolicy: 'cache-and-network',
    });

    const isFirstLoading = networkStatus === 1;

    return {
        dripSequences: data && data.lead,
        isLoading: loading,
        isFirstLoading: isFirstLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
